.form-container :global(.ql-editor) {
    height: 92px;
    max-height: 92px;
}
